import { useSelector } from 'react-redux';
// Gating for the beta receiving (ReceivingV2) and put-away (PutAwayV2) screens.
// An org may use them only at facilities listed in its PartySetting
// "FacReceivePutawayBetaAllow" (a CSV of facilityIds)
var parseFacilityCsv = function (csv) {
    return (csv !== null && csv !== void 0 ? csv : '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
};
export var isBetaFacility = function (csv, facilityId) {
    var _a;
    var fac = (_a = facilityId !== null && facilityId !== void 0 ? facilityId : localStorage.getItem('facilityId')) !== null && _a !== void 0 ? _a : '';
    return !!fac && parseFacilityCsv(csv).includes(fac);
};
export var useReceivingPutawayBetaGate = function () {
    var csv = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.receivingPutawayBetaFacilityIds; });
    if (csv === undefined || csv === null) {
        var cached = localStorage.getItem('receivingPutawayBetaFacilityIds');
        if (cached === null)
            return 'loading';
        return isBetaFacility(cached) ? 'allowed' : 'denied';
    }
    return isBetaFacility(csv) ? 'allowed' : 'denied';
};
